// extracted by mini-css-extract-plugin
var _1 = "UiLoader-module__blank--evk_f";
var _2 = "UiLoader-module__left--WHfM1";
var _3 = "UiLoader-module__mask--J0jub";
var _4 = "UiLoader-module__middle--zOq8M";
var _5 = "UiLoader-module__right--aBTEF";
var _6 = "UiLoader-module__root--OPqYl";
export { _1 as "blank", _2 as "left", _3 as "mask", _4 as "middle", _5 as "right", _6 as "root" }
